function getBrowser() {
    // Source: https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0

    if(isOpera) {
        return 'opera'
    }

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined'

    if(isFirefox) {
        return 'firefox'
    }

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]" })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification))

    if(isSafari) {
        return 'safari'
    }

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode

    if(isIE) {
        return 'ie'
    }

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia

    if(isEdge) {
        return 'edge'
    }

    // Chrome 1 - 79
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

    if(isChrome) {
        return 'chrome'
    }

    // Edge (based on chromium) detection
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1)

    if(isEdgeChromium) {
        return 'chromium'
    }

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS

    if(isBlink) {
        return 'blink'
    }
}

function windowUnloadEvent() {
    let method = (getBrowser() == 'safari')
                    ? 'onbeforeunload'
                    : 'onunload'

        window[method] = function() {
            stopLoading()
        }
}

export {
    getBrowser,
    windowUnloadEvent,
}